




import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-excel-popup',
  templateUrl: './excel-popup.component.html',
  styleUrls: ['./excel-popup.component.scss']
})
export class ExcelPopupComponent  {
  reportTypeForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ExcelPopupComponent>
  ) {
    // Create reactive form with validation
    this.reportTypeForm = this.fb.group({
      reportType: ['', Validators.required]
    });
  }

  /** Handle submit button click */
  onSubmit(): void {
    if (this.reportTypeForm.valid) {
      const selectedReport = this.reportTypeForm.value.reportType;
      console.log('Selected Report Type:', selectedReport);

      // Close popup and return selected value to parent
      this.dialogRef.close(selectedReport);
    }
  }

 closeModal() {
  this.dialogRef.close();
}

}
